module.exports = __webpack_public_path__ + "img/create_success.770e68e1.png";